<template>
  <form @submit.prevent="doReject">
    <div class="d-f-r d-fa-c d-fj-c">
      <img :src="value.thumb" alt="" style="height: 100px"/>
    </div>
    <div>
      <div class="mb-1">Message</div>
      <text-area
          placeholder="Enter message"
          :required="true"
          class="mb-3"
          v-model="form.message"
      />
    </div>
    <div class="form-group text-center m-t-20" style="display: flex; align-items: center; justify-content: center">
      <form-button
          type="primary"
          inputType="submit"
          text="Submit"
          :loading="loading"
          :block="true"
          style="width: 200px"
          class="btn btn-lg btn-block btn-rounded"
      />
    </div>
  </form>
</template>

<script>
import LoadingContainer from "@/components/Misc/LoadingContainer";
import FormButton from "@/components/Form/FormButton";
import AlertBox from "@/components/Misc/AlertBox";
import Breadcrumb from "@/components/Common/Breadcrumb";
import OrderStatus from "@/components/Common/OrderStatus";
import Modal from "@/components/Misc/Modal";
import LinkButton from "@/components/Misc/LinkButton";
import InputText from "@/components/Form/InputText";
import InputSelect from "@/components/Form/InputSelect";
import TextArea from "@/components/Form/TextArea";
import Uuid from "@/components/Common/Uuid";
import TrackingInfo from "@/components/Common/TrackingInfo";
import LightBox from "vue-image-lightbox";
import SizeOption from "@/components/OrderItem/SizeOption";
import ColorOption from "@/components/OrderItem/ColorOption";
import FormGroup from "@/components/Form/FormGroup";
import ImageSelect from "@/components/Common/ImagePicker";
import ImagePicker from "@/components/Form/ImagePicker";
import FilePicker from "@/components/Common/FilePicker";
import embApi from "@/store/api/emb";
import ErrorDisplay from "@/components/Common/ErrorDisplay";

export default {
  name: "DesignRejectForm",
  components: {
    ErrorDisplay,
    FilePicker,
    ImagePicker,
    ImageSelect,
    FormGroup,
    LoadingContainer,
    FormButton,
    AlertBox,
    Breadcrumb,
    OrderStatus,
    Modal,
    LinkButton,
    InputText,
    InputSelect,
    TextArea,
    Uuid,
    TrackingInfo,
    LightBox,
    SizeOption,
    ColorOption,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      form: {
        message: ''
      },
      loading: false,
    }
  },
  methods: {
    async doReject() {
      this.loading = true
      const api = embApi(this.$store.dispatch)
      const {data} = await api.rejectDesign(this.value.id, this.form)
      this.$emit('input', data)
    }
  }
}
</script>